import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthService } from '../../services/auth.service';
import { authActions } from '.';
import { catchError, EMPTY, map, of, switchMap } from 'rxjs';
import { Store } from '@ngrx/store';
import { ApiError } from '../../models/common/api-error';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { ratesActions } from '../rates';
import { AuthState } from './auth.state';
import { storeAuthKey } from '../reducers';
import * as Sentry from '@sentry/angular';

@Injectable({
  providedIn: 'root',
})
export class AuthEffects {
  constructor(
    private store$: Store,
    private actions$: Actions,
    private authService: AuthService,
  ) {}

  onLogin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(authActions.loginSuccess),
      withLatestFrom(this.store$),
      mergeMap(([action, store]) => {
        const authState: AuthState = store[storeAuthKey];
        Sentry.setUser({ id: authState.user.id, email: authState.user.email });

        return of(
          ratesActions.findAll({ vendorId: authState.user.vendor?.id }),
        );
      }),
    ),
  );

  onLogout$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(authActions.logoutSuccess),
        withLatestFrom(this.store$),
        mergeMap(([action, store]) => {
          Sentry.setUser(null);

          return EMPTY;
        }),
      ),
    { dispatch: false },
  );

  findCurrentUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(authActions.findCurrentUser),
      switchMap(() => {
        return this.authService.getUser().pipe(
          map((user) => authActions.findCurrentUserSuccess({ user })),
          catchError((error: ApiError) =>
            of(authActions.findCurrentUserError()),
          ),
        );
      }),
    ),
  );
}
